// Zustand store del dashboard jefe_cocina. Mantiene la cola de F11 + KDS resumen
// con auto-refresh cada 15s (ver hook useJefeCocinaAutoRefresh).
import { create } from 'zustand'
import {
  jefeCocinaApi,
  type AprobarBody,
  type KdsCard,
  type RechazarBody,
  type SolicitudCambioListItem,
  type SolicitudCambioResponse,
} from '../services/jefeCocina'

interface JefeCocinaState {
  pendientes: SolicitudCambioListItem[]
  kds: KdsCard[]
  loading: boolean
  error: string | null
  ultimaDecision: SolicitudCambioResponse | null

  refrescar: () => Promise<void>
  aprobar: (id: number, body: AprobarBody) => Promise<SolicitudCambioResponse>
  rechazar: (id: number, body: RechazarBody) => Promise<SolicitudCambioResponse>
  revertir: (id: number) => Promise<SolicitudCambioResponse>
  limpiarUltimaDecision: () => void
}

function extractError(err: unknown): string {
  if (err instanceof Error) return err.message
  // axios error shape sin tipo (evita any) — usamos unknown narrowing.
  const maybe = err as { response?: { data?: { detail?: string | { mensaje?: string } } } }
  const detail = maybe.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (detail && typeof detail === 'object' && 'mensaje' in detail && detail.mensaje) {
    return detail.mensaje
  }
  return 'Error desconocido'
}

export const useJefeCocinaStore = create<JefeCocinaState>((set, get) => ({
  pendientes: [],
  kds: [],
  loading: false,
  error: null,
  ultimaDecision: null,

  refrescar: async () => {
    set({ loading: true, error: null })
    try {
      const [pendientes, kds] = await Promise.all([
        jefeCocinaApi.listarPendientes(),
        jefeCocinaApi.listarKdsResumen(),
      ])
      set({ pendientes, kds, loading: false })
    } catch (err) {
      set({ loading: false, error: extractError(err) })
    }
  },

  aprobar: async (id, body) => {
    const res = await jefeCocinaApi.aprobar(id, body)
    set({ ultimaDecision: res })
    await get().refrescar()
    return res
  },

  rechazar: async (id, body) => {
    const res = await jefeCocinaApi.rechazar(id, body)
    set({ ultimaDecision: res })
    await get().refrescar()
    return res
  },

  revertir: async (id) => {
    const res = await jefeCocinaApi.revertir(id)
    set({ ultimaDecision: res })
    await get().refrescar()
    return res
  },

  limpiarUltimaDecision: () => set({ ultimaDecision: null }),
}))
